module.exports = __webpack_public_path__ + "static/default-2338c5fc6ce346e2900a3d414aa229ba.jpg";